const filter = (value): string => {
  if (!value) {
    return ''
  }

  switch (value) {
    case 'negative':
      return 'negativo'

    case 'neutral':
      return 'neutro'

    case 'positive':
      return 'positivo'

    default:
      return value
  }
}

export default filter
